import { SHARED_ENV } from './environment.shared';

export const environment = {
  ...SHARED_ENV,
  production: true,
  firebase: {
    apiKey: 'AIzaSyAgf6ZfjP8ihPRK7pIPt98yki42QGjrWsE',
    authDomain: 'fir-d34ee.firebaseapp.com',
    databaseURL: 'https://fir-d34ee.firebaseio.com',
    projectId: 'fir-d34ee',
    storageBucket: 'fir-d34ee.appspot.com',
    messagingSenderId: '155329937657'
  },
  mainSystemUrl: 'https://sunip.legalsight.com',
  forecasterUrl: 'https://chiefip.legalsight.com',
  subscribeKey: 'sub-c-2ee77e1e-c7d7-11e8-8f2a-6ea01b4be699',
  local: false,
  raygunKey: '8eS6ffrx62kQYwborG0SKQ==',
  msClarityProjectId: '',
  msClarityEnabled: false,
};
